export default __webpack_public_path__ + "static/media/boogiee.bc05ea50.svg";